import React, { useEffect } from 'react';
import { useTranslator } from '@bluebeam/react-i18n';
import { RegionConfig } from 'constants/regionConfig';

export interface IRegionalConfig {
  readonly id: string;
  readonly href: string;
  readonly label: string;
  readonly languageCode: string;
}
export const useRegionalConfig = (): ReadonlyArray<IRegionalConfig> => {
  const { translate } = useTranslator();
  const [regionalConfigs, setRegionalConfigs] = React.useState<
    IRegionalConfig[]
  >([]);

  useEffect(() => {
    const configs = RegionConfig.map((config) => ({
      id: config.countryCode,
      href: config.dashboardUrl,
      label: translate(config.labelTranslationKey as `string:string`),
      languageCode: config.languageKey,
    }));
    setRegionalConfigs(configs);
  }, [RegionConfig, translate]);

  return regionalConfigs;
};
